export default "__VITE_ASSET__D09Hy$_j__"